class ReceivedAsTrending {
    constructor(data) {
        this.take = 10;
        this.data = data;
    }

    get() {
        this.buildFilters();
        return this.filters;
    }

    buildFilters() {
        this.filters = {
            'user_id': App.user.id,
            'reviewed': false,
            'not_reviewed': false,
            'order_by_financial': 'desc',
            'gradually': true,
            'published': true,
            'take': this.take,
            'skip': this.getSkip(),
        };


        // if (App.filters.available_in.length){
            this.filters.available_in = App.filters.available_in;
        // }

        if (App.filters.licensed_in.length){
            this.filters.licensed_in = App.filters.licensed_in;
        }

        // if (App.filters.genres.length){
            this.filters.genres = App.filters.genres;
        // }         
    }
 
    getSkip() {
        return (this.data.page - 1) * this.take;
    }
 
}

export default ReceivedAsTrending;